import React from 'react';

import {
  Switch, Route, useRouteMatch, Redirect,
} from 'react-router-dom';

import Header from '@components/HomeHeader/HomeHeader';
import Footer from '@components/Footer/Footer';
import Home from '../home/Home';
import EnvironmentIntro from '../Kechuang/intro/index';
import EnvironmentRegulation from '../Kechuang/regulation/index';
import EnvironmentLaureates from '../Kechuang/laureates/index';
import QingshanIntro from '../Qingshan/intro/intro';
import QingshanRegulation from '../Qingshan/regulation/regulation';
import QingshanApplication from '../Qingshan/application/application';
import QingshanQA from '../Qingshan/qa/qa';
import QingshanLaureates from '../Qingshan/laureates/laureates';
import Trend from '../trend/index';
import NewsDetail from '../trend/NewsDetail';
import New from '../new';
import './AppLayout.scss';

const AppLayout = ({ pathPrefix = '' }) => (
  <div className="app-layout">
    <Header />
    <div className="app-body">
      <Switch>
        <Route path={`${pathPrefix}/home`} exact component={Home} />
        <Route path={`${pathPrefix}/environment/intro`} component={EnvironmentIntro} />
        <Route path={`${pathPrefix}/environment/regulation`} component={EnvironmentRegulation} />
        <Route path={`${pathPrefix}/environment/laureates`} component={EnvironmentLaureates} />
        <Route path={`${pathPrefix}/award/laureates`} component={QingshanLaureates} />
        <Route path={`${pathPrefix}/award/application`} component={QingshanApplication} />
        <Route path={`${pathPrefix}/award/regulation`} component={QingshanRegulation} />
        <Route path={`${pathPrefix}/award/intro`} component={QingshanIntro} />
        <Route path={`${pathPrefix}/award/question-answer`} component={QingshanQA} />
        <Route path={`${pathPrefix}/trend/detail`} component={NewsDetail} />
        <Route path={`${pathPrefix}/trend`} exact component={Trend} />
        <Route path={`${pathPrefix}/new`} component={New} />
        <Route path={`${pathPrefix}`} exact component={Home} />
        <Redirect from="*" to="/home" />
      </Switch>
    </div>
    <Footer />
  </div>
);

export default AppLayout;
